export default {
  available: 'Available',
  selected: 'Selected',
  noItemsSelected: 'No items selected',
  confirm: 'Are you sure?',
  fields: {
    action: 'Action',
    name: 'Name',
    added: 'Added',
  },
  status: {
    title: 'Status',
    added: 'Added',
    noAdded: 'No added',
  },
  search: 'Search',
  noMatchingResults: 'No matching records found',
  noDataAvailable: 'No data available',
  rowsPerPageText: 'Rows per page:',
  records: 'Records',
  from: 'from',
  add: 'Add',
  all: 'All',
  buttons: {
    remove: 'Dalete',
    add: 'Add',
    removeMany: 'Delete many',
    addMany: 'Add many',
    close: 'Close',
  },
}
